import Blob from '@/lib/assets/shapes/blob.svg';
import Bow from '@/lib/assets/shapes/bow.svg';
import Circle from '@/lib/assets/shapes/circle.svg';
import Grid from '@/lib/assets/shapes/grid.svg';
import Plus from '@/lib/assets/shapes/plus.svg';
import Wave from '@/lib/assets/shapes/wave.svg';
import QuotationMark from '@/lib/assets/shapes/quotation-marks.svg';
import { HTMLAttributes } from 'react';

export type Shape = 'blob' | 'bow' | 'circle' | 'grid' | 'plus' | 'wave' | 'quotation-mark';

type ShapeProps = HTMLAttributes<SVGElement> & {
  shape: Shape;
};

const ShapeElement = ({ shape, ...props }: ShapeProps) => {
  switch (shape) {
    case 'blob':
      return <Blob {...props} />;
    case 'bow':
      return <Bow {...props} />;
    case 'circle':
      return <Circle {...props} />;
    case 'grid':
      return <Grid {...props} />;
    case 'plus':
      return <Plus {...props} />;
    case 'wave':
      return <Wave {...props} />;
    case 'quotation-mark':
      return <QuotationMark {...props} />;
    default:
      return null;
  }
};

export default ShapeElement;
